export default "__VITE_ASSET__UaVyNVs9__"